exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wx-voice-div[data-v-b62a054e] {\n  padding: 5px;\n  background-color: #eaeaea;\n  border-radius: 10px;\n}\n.amr-duration[data-v-b62a054e] {\n  font-size: 11px;\n  margin-left: 5px;\n}", ""]);

// exports
